export const NutritionCodeEnum = {
  Fruit: 'F',
  Vegetable: 'V',
  Grain: 'G',
  Protein: 'P',
  Milk: 'M',
  FederalType1Meal: '1',
  SecondMeal: '2',
  NA: 'X',
  FruitGrain: 'FG',
  TwoFruit: 'FF',
  TwoGrain: 'GG',
  TwoFruitGrain: 'FFG',
  FruitTwoGrain: 'FGG',
  FruitVegetable: 'FV',
  FruitProtein: 'FP',
  GrainVegetable: 'GV',
  ProteinVegetable: 'PV',
  GrainProtein: 'GP',
  FruitGrainVegetable: 'FGV',
  FruitProteinVegetable: 'FPV',
  FruitGrainProtein: 'FGP',
  GrainProteinVegetable: 'GPV',
  FruitGrainProteinVeg: 'FGPV',
  TwoVegetable: 'VV',
  TwoFruitProtein: 'FFP',
  TwoVegetableGrain: 'VVG',
  TwoVegetableProtein: 'VVP',
  VegetableTwoGrain: 'VGG',
  ReimbursableSnack: 'RS',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/NutritionCodeEnum.js